export default "__VITE_ASSET__5322c72c__"